import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

export const GetServiceRequests = async (customerID, requestID, entityType = 0) => {

  const accesstoken = getToken();
  if (accesstoken) {
    try {
      const response = await fetch(`${dev_baseUrl}/ServiceRequest/getServiceRequest/${requestID}/${customerID}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
      });
      
      const data = await response.json();        
      // console.log(data)

      const colors = ["error", "info", "warning", "primary", "success"];

      const RandomColor = () => {
        const randomIndex = Math.floor(Math.random() * colors.length);
        return colors[randomIndex];
      };

      const title =['REQ-','AST-','EST-','WRO-'];
        
      if (response.ok && !data.isError) {   
        //console.log(data.result)
        const formattedData = data.result.map((item) => ({          
          id: `${title[entityType]}${item.requestID.toString().padStart(3, "0")}`, // Format ID
          requestID: item.requestID,
          requestTitle: item.requestTitle,
          isDeposit: item.isDeposit,
          depositAmount: item.depositAmount,
          depositAmountPaid: item.depositAmountPaid,
          depositUtilizedAmount: item.depositUtilizedAmount,
          customerName: item.customerName,
          jobsiteName: item.jobSiteName,
          jobsiteAddress: item.jobSiteAddress || "N/A", // Add a fallback if address is missing
          completeWorkBy: new Date(item.completeWorkBy).toLocaleDateString(), // Format date
          completeWorkBy_original: item.completeWorkBy,
          createBy: item.createdBy,
          requestedOn: new Date(item.createDate).toLocaleDateString(), // Format date
          source: item.requestSource,
          tags: item.tags?.map((tag) => tag.tagName) || [], // Extract tag names
          status: item.status,
          jobsiteContactID: item.jobsiteContactID,
          jobsiteID: item.jobSiteID,
          preferred_days: item.availabilityDays,
          preferred_time: item.availabilityTime,
          customerID: item.customerID,
          entityType: item.entityType,
          assignedTo: item.assignedToUsers,
          totalbudgetedHours: item.totalBudgetedHours,
          totalbudgetedCost: item.totalBudgetedCost,
          totalactualHours: item.totalActualHours,
          totalactualCost: item.totalActualCost,
          totalestimatedProfit: item.totalEstimatedProfit,
          totalbudgetedPrice: item.totalBudgetedPrice,
          completedjobs: item.completedJobs,
          totaljobs: item.totalJobs,
          convertedfrom: item.convertedFrom,
          schedulestartdate: new Date(item.scheduleStart).toLocaleDateString(),
          scheduleenddate: new Date(item.scheduleEnd).toLocaleDateString(),
        

        }));     
        return formattedData;

                
      } else {
        console.error('Server error:', data);
        return [];
      }
    } catch (error) {
      console.error('Network error:', error);
      return [];
    }
  } else {
    console.warn('Access token is not available.');
    return { form: 'Access token is missing.' };
  }
};

export const GetServiceRequestRaw = async(customerID, requestID) => {
  const accesstoken = getToken();
  if (accesstoken) {
    try {
      const response = await fetch(`${dev_baseUrl}/ServiceRequest/getServiceRequest/${requestID}/${customerID}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
      });
      
      const data = await response.json();        
      
      if (response.ok && !data.isError) {               
        return data;        
      } else {
        console.error('Server error:', data);
        return [];
      }
    } catch (error) {
      console.error('Network error:', error);
      return [];
    }
  } else {
    console.warn('Access token is not available.');
    return { form: 'Access token is missing.' };
  }
}

